export default __webpack_public_path__ + "static/media/support2.6ee0506f.svg";